import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Gate for a route that needs one permission flag from `/api/auth/me`. The API enforces the
 * same rule — this only avoids showing a screen that would fail anyway.
 */
export default function PermissionRoute({ permission }) {
  const { user } = useAuth();

  if (!user?.[permission]) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}
